import { entryPointId } from 'settings/app/constants'

/**
 * data keys for accordion which should skipped at compare details
 * @type {string[]}
 */
export const SKIP_DETAIL_KEY_FOR_COMPARE = [
  'slideshowOffice',
  'slideshow',
  'costs',
]

/**
 * defines which results habe compare able data (dynamic tile data)
 * @type {string[]}
 */
export const RESULT_HAS_COMPARE_DATA = [
  entryPointId.HOSPITALS,
  entryPointId.DAYANDNIGHTCARE,
  entryPointId.CAREHOMES,
  entryPointId.CARESERVICES,
  entryPointId.CARESUPPORT,
]

/**
 * care results which has contribution data
 * @type {string[]}
 */
export const RESULT_HAS_CONTRIBUTION = [
  entryPointId.DAYANDNIGHTCARE,
  entryPointId.CAREHOMES,
  entryPointId.CARESERVICES,
]
